import axios from 'axios';
import {  getToken, deleteToken } from '../utils/auth';

// Axios instance creation
const apiClient = axios.create({
    baseURL: 'https://api.conomy.io/api/v1', // Replace with your actual API URL
//    baseURL: 'http://127.0.0.1:9090/api/v1', // Replace with your actual API URL
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add token to headers
apiClient.interceptors.request.use(
    async (config) => {
        const token = getToken();

        console.log(token)
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor to handle token expiration
apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response && error.response.status === 401) {
            console.log('Unauthorized - Redirect to login');
            await deleteToken();
        }
        return Promise.reject(error);
    }
);

export default apiClient;
